module.exports = __webpack_public_path__ + "static/media/line-single-02.498bafa1.png";